/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularConnectedNoInternet4Bar: {
  name: 'signal-cellular-connected-no-internet-4-bar';
  data: string;
} = {
  name: 'signal-cellular-connected-no-internet-4-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"/></svg>`
};
